const appendObjectToFormData = (formData: FormData, prefix: string, obj: any) => {
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const newKey = prefix ? `${prefix}.${key}` : key;

            if (Array.isArray(value)) {
                // Handle arrays
                value.forEach((item: any, index: number) => {
                    if (typeof item === 'object' && item !== null) {
                        // Recursively handle nested objects in array
                        appendObjectToFormData(formData, `${newKey}[${index}]`, item);
                    } else {
                        // Append item in array to FormData
                        formData.append(`${newKey}[${index}]`, item);
                    }
                });
            } else if (typeof value === 'object' && value !== null) {
                // Recursively handle nested objects
                appendObjectToFormData(formData, newKey, value);
            } else {
                // Append property to FormData
                formData.append(newKey, value);
            }
        }
    }
}

export default appendObjectToFormData;
